<svelte:options customElement="hb-player-live-camera-ptz" />

<script lang="ts">
  import pkg from "../../../package.json";
  import { addComponent, LanguageTranslator } from "wc-js-utils";
  import type { Component as PlayerLiveComponent } from "../player-live/types/webcomponent.type";
  import type { Component as TableComponent } from "../table/types/webcomponent.type";
  import type { Component, Events } from "./types/webcomponent.type";
  import type { Events as PlayerLiveEvents } from "../player-live/types/webcomponent.type";
  import type { Events as PadJoystickEvents } from "../pad-joystick/types/webcomponent.type";
  import type { Events as DialogEvents } from "../dialog/types/webcomponent.type";
  import type { Events as PlayerliveEvents } from "../player-live/types/webcomponent.type";
  import type { Events as TableEvents } from "../table/types/webcomponent.type";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  type TrectClicks = {
    start?: { x: number; y: number };
    end?: { x: number; y: number };
  };
  type Trect = { top: number; left: number; width: number; height: number };

  const defaultConfiguration: Component["configuration"] = {
    joystick: true,
    presets: true,
    deletePreset: true,
    addPreset: true,
    switchPreset: true,
    home: true,
    zoom: {
      in: true,
      out: true,
    },
    pan: true,
    tilt: true,
    clickToCenter: true,
    settings: true,
  };

  let {
    id = "",
    // style = "",
    live_uri = "",
    media_type = "auto",
    presets = [],
    position = "right-bottom",
    configuration = defaultConfiguration,
    current_preset = "",
    is_home = undefined,
    is_ptz_connected = undefined,
    is_ptz_panel_opened = undefined,
  }: Component = $props();

  const tablePresetsHeaders: TableComponent["headers"] = [
    {
      label: "Name",
      key: "name",
      copyTxt: true,
    },
    {
      label: "Token",
      key: "token",
      copyTxt: true,
    },
  ];
  const tablePresetsActions: TableComponent["actions"] = [
    {
      name: "goto",
      type: "icon",
      iconOrText: "arrow-right-circle",
    },
    {
      name: "delete",
      type: "icon",
      iconOrText: "x-circle-fill",
      btnClass: "danger",
    },
  ];

  let htmlVideoElement: HTMLVideoElement | undefined = $state();
  let selectedPresetToken = $state("");
  const movementSettings = {
    precision: 50,
    speed: 50,
  };

  let time = $state(new Date().toLocaleTimeString());
  let tablePresetsRows = $derived(
    presets?.map((p) => {
      return {
        _id: p.token + "_" + p.name,
        name: p.name,
        token: p.token,
      };
    }),
  );

  let isVideoPaused = $state(true);
  let isVideoPlaying = $state(false);
  let isVideoLoaded = $state(false);

  let showTablePresets = $state(false);
  let showConfirmAddSceneToPreset = $state(false);
  let showConfirmDeletePreset = $state(false);
  let showConfirmGoToPreset = $state(false);
  let showGoToHomeConfirm = $state(false);
  let isGridOpen = $state(false);
  let dpadOrJoystick: "dpad" | "joystick" = $state("dpad");
  let selectingZone = $state(false);
  let rect: Trect = $state({ top: 0, left: 0, width: 0, height: 0 });
  let rectClicks: TrectClicks = {};
  $effect(() => {
    // if (style) {
    //     playerLiveStyleSetup?.vars
    //   );
    //     padJoystickStyleSetup?.vars
    //   );
    //     tableStyleSetup?.vars
    //   );
    //     dialogStyleSetup?.vars
    //   );
    // }

    if ((is_ptz_connected as unknown as string) === "") is_ptz_connected = true;
    if (!is_ptz_connected) is_ptz_connected = false;
    if (typeof is_ptz_connected === "string")
      is_ptz_connected =
        is_ptz_connected === "true" || is_ptz_connected === "yes"
          ? true
          : false;

    if ((is_ptz_panel_opened as unknown as string) === "")
      is_ptz_panel_opened = true;
    if (!is_ptz_panel_opened) is_ptz_panel_opened = false;
    if (typeof is_ptz_panel_opened === "string")
      is_ptz_panel_opened =
        is_ptz_panel_opened === "true" || is_ptz_panel_opened === "yes"
          ? true
          : false;

    if ((is_home as unknown as string) === "") is_home = true;
    if (!is_home) is_home = false;
    if (typeof is_home === "string")
      is_home = is_home === "true" || is_home === "yes" ? true : false;

    if (typeof configuration === "string") {
      try {
        configuration = JSON.parse(configuration);
      } catch (err) {}
    }
    if (typeof presets === "string") {
      try {
        presets = JSON.parse(presets);
      } catch (err) {}
    }
  });
  setInterval(() => {
    time = new Date().toLocaleTimeString();
  }, 1000);
  function zoomAction(direction: "in" | "out") {
    if (!configuration?.zoom)
      return console.error("Zoom is not enabled in the configuration");
    if (!configuration.zoom[direction])
      return console.error(
        `Zoom ${direction} is not enabled in the configuration`,
      );
    const zoomActionEventPayload: Events["zoomAction"] = {
      time: new Date(),
      id,
      movementSettings,
      direction,
    };

    dispatch("zoomAction", zoomActionEventPayload);
  }
  function goToHome() {
    if (!configuration?.home)
      return console.error("Go to home is not enabled in the configuration");
    const goToHomeEventPayload: Events["goToHome"] = {
      time: new Date(),
      id,
      movementSettings,
    };
    dispatch("goToHome", { id, movementSettings });
  }
  function setPreset() {
    if (!configuration?.addPreset)
      return console.error(
        "Add scene to preset is not enabled in the configuration",
      );
    const addAsPresetEventPayload: Events["setPreset"] = {
      time: new Date(),
      id,
    };

    dispatch("setPreset", addAsPresetEventPayload);
  }
  function goToSelectedArea() {
    if (!configuration?.clickToCenter)
      return console.error(
        "Click to center is not enabled in the configuration",
      );
    const videoRect = htmlVideoElement?.getBoundingClientRect();
    const goToSelectedAreaEventPayload: Events["goToSelectedArea"] =
      Object.assign(
        {
          time: new Date(),
          id,
          movementSettings,
          htmlVideoElementWidth: videoRect?.width as number,
          htmlVideoElementHeight: videoRect?.height as number,
        },
        rect,
      );

    dispatch("goToSelectedArea", goToSelectedAreaEventPayload);
    selectingZone = false;
    rect = { top: 0, left: 0, width: 0, height: 0 };
    rectClicks = {};
  }
  function openPresetsModal() {
    if (!configuration?.presets)
      return console.error("Presets is not enabled in the configuration");
    showTablePresets = !showTablePresets;
  }
  function confirmAddSceneToPresets() {
    if (!configuration?.addPreset)
      return console.error(
        "Add scene to preset is not enabled in the configuration",
      );
    showConfirmAddSceneToPreset = !showConfirmAddSceneToPreset;
  }
  function confirmGoToHome() {
    if (!configuration?.home)
      return console.error("Go to home is not enabled in the configuration");
    showGoToHomeConfirm = !showGoToHomeConfirm;
  }
  function goToPreset(token: string) {
    if (!configuration?.switchPreset)
      return console.error("Switch preset is not enabled in the configuration");

    const preset = presets?.find?.((p) => p.token === token);
    if (preset) {
      const goToPresetEventPayload: Events["goToPreset"] = Object.assign(
        { time: new Date(), playerId: id, movementSettings },
        preset,
      );

      dispatch("goToPreset", goToPresetEventPayload);
    } else console.error("Preset not found");
  }

  function initializeVideo() {
    const initVideoEventPayload: Events["initVideo"] = {
      time: new Date(),
      id,
      htmlVideoElement,
    };
    dispatch("initVideo", initVideoEventPayload);

    if (htmlVideoElement) {
      htmlVideoElement.onloadedmetadata = () => {
        isVideoLoaded = true;
      };
      htmlVideoElement.onpause = () => {
        isVideoPaused = true;
        isVideoPlaying = false;
      };
      htmlVideoElement.onplay = () => {
        isVideoPaused = false;
        isVideoPlaying = true;
      };
      htmlVideoElement.onclick = (element_click) => {
        if (selectingZone) {
          const containerPos = htmlVideoElement?.getBoundingClientRect();

          const newClick = {
            x: element_click.clientX - (containerPos?.left as number),
            y: element_click.clientY - (containerPos?.top as number),
            width: 0,
            height: 0,
          };
          if (!rectClicks.start) {
            rectClicks = { start: newClick };
          } else {
            rectClicks = { start: rectClicks.start, end: newClick };
            goToSelectedArea();
          }
        }
      };
      htmlVideoElement.onmousemove = (element_click) => {
        if (selectingZone) {
          const newClick = {
            x: element_click.clientX,
            y: element_click.clientY,
          };
          if (rectClicks.start) {
            rectClicks = { start: rectClicks.start, end: newClick };
            rect = {
              top:
                (rectClicks as any).start.y > (rectClicks as any).end.y
                  ? (rectClicks as any).end.y
                  : (rectClicks as any).start.y,
              left:
                (rectClicks as any).start.x > (rectClicks as any).end.x
                  ? (rectClicks as any).end.x
                  : (rectClicks as any).start.x,
              width: Math.abs(
                (rectClicks?.start?.x || 0) - (rectClicks?.end?.x || 0),
              ),
              height: Math.abs(
                (rectClicks?.start?.y || 0) - (rectClicks?.end?.y || 0),
              ),
            };
          }
        }
      };
    }
  }

  function deletePreset(token: string) {
    if (!configuration?.deletePreset)
      return console.error("Delete preset is not enabled in the configuration");

    const preset = presets?.find((p) => p.token === token);
    if (preset) {
      const deletePresetEventPayload: Events["deletePreset"] = Object.assign(
        { time: new Date(), playerId: id },
        preset,
      );

      dispatch("deletePreset", deletePresetEventPayload);
    } else console.error("Preset not found");
  }

  function sendJoystickPosition(
    position: PadJoystickEvents["sendJoystickPosition"],
  ) {
    if (!configuration?.joystick || configuration?.pan || configuration?.tilt)
      return console.error(
        "Pan and Tilt on joystick are not enabled in the configuration",
      );
    dispatch("sendJoystickPosition", {
      id,
      x: position.x,
      y: position.y,
      cardinalDirection: position.cardinalDirection,
      joyId: position.id,
      movementSettings,
    });
  }
  function sendDirection(direction: PadJoystickEvents["sendDirection"]) {
    if (configuration?.pan && configuration?.tilt)
      dispatch("sendDirection", {
        id,
        movementSettings,
        direction: direction.direction,
        joyId: direction.id,
      });
    else console.error("Pan and Tilt are not enabled in the configuration");
  }
  function showGrid() {
    isGridOpen = !isGridOpen;
  }
  function selectZone() {
    if (!configuration?.clickToCenter)
      return console.error(
        "Click to center is not enabled in the configuration",
      );
    selectingZone = !selectingZone;
  }
  function showJoystick() {
    if (dpadOrJoystick === "dpad") {
      if (!configuration?.joystick)
        return console.error("Joystick is not enabled in the configuration");

      dpadOrJoystick = "joystick";
    } else {
      dpadOrJoystick = "dpad";
    }
  }

  function showSettings() {}
  function presetsActionClick(c: TableEvents["tableaction"]) {
    console.log(c, "presetclick");
    showTablePresets = false;
    const presetToken = presets?.find((f) =>
      c.itemId.includes(f.token + "_"),
    )?.token;
    if (presetToken) selectedPresetToken = presetToken;

    switch (c.action) {
      case "goto":
        showConfirmGoToPreset = true;
        break;
      case "delete":
        showConfirmDeletePreset = true;
        break;
      default:
        return console.error("Action not found");
    }
  }

  function playOrPauseVideo() {
    if (!htmlVideoElement) return console.error("Video element not found");
    if (htmlVideoElement.paused) htmlVideoElement.play();
    else htmlVideoElement.pause();
  }

  addComponent({
    repoName: "@htmlbricks/hb-player-live",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-pad-joystick",
    version: pkg.version,
  });
  addComponent({ repoName: "@htmlbricks/hb-table", version: pkg.version });
  addComponent({ repoName: "@htmlbricks/hb-dialog", version: pkg.version });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>

<!-- This Dialog allows to manage the presets -->
<hb-dialog
  onmodalShow={(s: { detail: DialogEvents["modalShow"] }) => {
    showTablePresets = s.detail.show;
  }}
  title="Presets"
  show={showTablePresets ? "yes" : "no"}
  hide_confirm="yes"
>
  <!-- <div slot="header">
		<h5 class="modal-title">Presets</h5>
	</div> -->
  <div slot="body-content">
    {#if tablePresetsRows?.length}
      <hb-table
        rows={JSON.stringify(tablePresetsRows)}
        headers={JSON.stringify(tablePresetsHeaders)}
        actions={JSON.stringify(tablePresetsActions)}
        size="12"
        disablepagination={tablePresetsRows && tablePresetsRows.length < 12
          ? "yes"
          : "no"}
        ontableaction={(e: { detail: TableEvents["tableaction"] }) => {
          presetsActionClick(e.detail);
        }}
      ></hb-table>
    {/if}
  </div>
  <!-- <div slot="footer">
		<button type="button" class="btn btn-primary" onclick={() => openPresetsModal()}>Close</button>
	</div> -->
</hb-dialog>

<!-- This Dialog allows to confirm the addSceneToPreset -->

<hb-dialog
  onmodalShow={(s: { detail: DialogEvents["modalShow"] }) => {
    showConfirmAddSceneToPreset = s.detail.show;
  }}
  title="Add Scene to Preset"
  show={showConfirmAddSceneToPreset ? "yes" : "no"}
  onmodalConfirm={(e: { detail: DialogEvents["modalConfirm"] }) => {
    if (e?.detail?.confirm) setPreset();
  }}
>
  <!-- <div slot="header">
		<h5 class="modal-title">Presets</h5>
	</div> -->
  <div slot="body-content">Are You sure to add this scene to the preset?</div>
  <!-- <div slot="footer">
		<button type="button" class="btn btn-primary" onclick={() => openPresetsModal()}>Close</button>
	</div> -->
</hb-dialog>

<!-- This Dialog allows to confirm the Go To Home Movement -->

<hb-dialog
  onmodalShow={(s: { detail: DialogEvents["modalShow"] }) => {
    showGoToHomeConfirm = s.detail.show;
  }}
  title="Go to Home"
  show={showGoToHomeConfirm ? "yes" : "no"}
  onmodalConfirm={(e: { detail: DialogEvents["modalConfirm"] }) => {
    if (e?.detail?.confirm) goToHome();
  }}
  confirmlabel="GO"
>
  <div slot="body-content">Are You sure to go To Home?</div>
</hb-dialog>
<!-- This Dialog allows to confirm the delete preset -->

<hb-dialog
  id={"del_" + selectedPresetToken}
  onmodalShow={(s: { detail: DialogEvents["modalShow"] }) => {
    showConfirmDeletePreset = s.detail.show;
  }}
  title="Go to Preset {selectedPresetToken
    ? presets?.find((f) => f.token === selectedPresetToken)?.token
    : ''}"
  show={showConfirmDeletePreset ? "yes" : "no"}
  confirmlabel="delete"
  confirm_btn_class="danger"
  onmodalConfirm={(e: { detail: DialogEvents["modalConfirm"] }) => {
    console.log(e.detail, "detail");
    if (e?.detail?.confirm) deletePreset(e.detail.id.split("del_")[1]);
  }}
>
  <div slot="body-content">
    Are You sure to DELETE preset {selectedPresetToken
      ? presets?.find((f) => f.token === selectedPresetToken)?.token
      : ""}?
  </div>
</hb-dialog>

<!-- This Dialog allows to confirm the Go To Preset -->

<hb-dialog
  id={"goto_" + selectedPresetToken}
  onmodalShow={(s: { detail: DialogEvents["modalShow"] }) => {
    showConfirmGoToPreset = s.detail.show;
  }}
  title="Go to Preset {selectedPresetToken
    ? presets?.find((f) => f.token === selectedPresetToken)?.token
    : ''}"
  show={showConfirmGoToPreset ? "yes" : "no"}
  confirmlabel="go"
  confirm_btn_class="light"
  onmodalConfirm={(e: { detail: DialogEvents["modalConfirm"] }) => {
    console.log(e.detail.id.split("goto")[1], "detail");
    if (e?.detail?.confirm) goToPreset(e.detail.id.split("goto_")[1]);
  }}
>
  <div slot="body-content">
    Are You sure to GO to preset "{selectedPresetToken
      ? presets?.find((f) => f.token === selectedPresetToken)?.token
      : ""}"?
  </div>
</hb-dialog>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
  id="container"
  style="cursor: {selectingZone ? 'crosshair' : ''};"
  onmousemove={(element_click) => {
    if (selectingZone) {
      const containerPos = htmlVideoElement?.getBoundingClientRect();

      const newClick = {
        x: element_click.clientX - (containerPos?.left as number),
        y: element_click.clientY - (containerPos?.top as number),
      };
      if (rectClicks.start) {
        rectClicks = { start: rectClicks.start, end: newClick };
        rect = {
          top:
            (rectClicks as any).start.y > (rectClicks as any).end.y
              ? (rectClicks as any).end.y
              : (rectClicks as any).start.y,
          left:
            (rectClicks as any).start.x > (rectClicks as any).end.x
              ? (rectClicks as any).end.x
              : (rectClicks as any).start.x,
          width: Math.abs(
            (rectClicks?.start?.x || 0) - (rectClicks?.end?.x || 0),
          ),
          height: Math.abs(
            (rectClicks?.start?.y || 0) - (rectClicks?.end?.y || 0),
          ),
        };
      }
    }
  }}
>
  <hb-player-live
    onhtmlVideoInit={(e: { detail: PlayerliveEvents["htmlVideoInit"] }) => {
      console.log(e.detail, "detailvid");
      htmlVideoElement = e.detail.video;
      initializeVideo();
    }}
    no_controls="yes"
    id="player"
    mediauri={live_uri}
    {media_type}
  ></hb-player-live>
  <div
    id="area_selector"
    style="display:{selectingZone
      ? 'inherit'
      : 'none'}; width:{rect.width}px; height:{rect.height}px;top:{rect.top}px;left:{rect.left}px;"
  ></div>
  <div id="grid" style="display:{isGridOpen ? 'inherit' : 'none'}">
    <table id="grid_table">
      <tbody>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
  {#if is_ptz_connected}
    {#if is_ptz_panel_opened}
      <div id="controller">
        <div id="panel">
          <div id="joystick" class="area">
            {#if dpadOrJoystick === "dpad"}
              <hb-pad-joystick
                id={"pad_" + dpadOrJoystick}
                onsendDirection={(e: {
                  detail: PadJoystickEvents["sendDirection"];
                }) => {
                  sendDirection(e.detail);
                }}
                pad_or_joystick="dpad"
                size="60px"
              ></hb-pad-joystick>
            {:else}
              <hb-pad-joystick
                id={"pad_" + dpadOrJoystick}
                onsendJoystickPosition={(e: {
                  detail: PadJoystickEvents["sendJoystickPosition"];
                }) => {
                  sendJoystickPosition(e.detail);
                }}
                pad_or_joystick="joystick"
                size="60px"
              ></hb-pad-joystick>
            {/if}
          </div>
          <div id="buttons" class="area">
            <div class="buttons has-addons mr-2 is-inline-flex">
              <button
                type="button"
                disabled={configuration?.zoom?.in ? false : true}
                onclick={() => zoomAction("in")}
                class="button is-small is-light"
                aria-label="Zoom In"
              >
                <i class="bi bi-zoom-in"></i>
              </button>
              <button
                type="button"
                disabled={configuration?.zoom?.out ? false : true}
                onclick={() => zoomAction("out")}
                class="button is-small is-light"
                aria-label="Zoom Out"
              >
                <i class="bi bi-zoom-out"></i>
              </button>
            </div>
            <button
              type="button"
              aria-label="Go to home"
              disabled={configuration?.home ? false : true}
              onclick={() => confirmGoToHome()}
              class="button is-small {is_home ? 'is-primary' : 'is-light'}"
            >
              <i class="bi bi-house-door-fill"></i>
            </button>
            <button
              type="button"
              aria-label="select zone"
              disabled={configuration?.clickToCenter ? false : true}
              onclick={() => selectZone()}
              class="button is-small {selectingZone ? 'is-primary' : 'is-light'}"
            >
              <i class="bi bi-square"></i>
            </button>
          </div>
          <div id="speed" class="area">
            <span class="slider_label">speed:</span>
            <input
              class="range"
              type="range"
              bind:value={movementSettings.speed}
            />
          </div>
          <div id="precision" class="area">
            <span class="slider_label">precision:</span>
            <input
              class="range"
              type="range"
              bind:value={movementSettings.precision}
            />
          </div>
          <div id="presets_view" class="area">
            <button
              type="button"
              aria-label="showGrid"
              onclick={() => showGrid()}
              class="button is-small {isGridOpen ? 'is-primary' : 'is-light'}"
            >
              <i class="bi bi-grid-3x3"></i>
            </button>
            <button
              type="button"
              disabled={configuration?.joystick ? false : true}
              onclick={() => showJoystick()}
              class="button is-small {dpadOrJoystick && dpadOrJoystick === 'dpad'
                ? 'is-light'
                : 'is-primary'}"
              aria-label="Toggle joystick mode"
            >
              <i class="bi bi-joystick"></i>
            </button>

            <button
              type="button"
              style="float:right;margin-right:5px;"
              onclick={() => htmlVideoElement?.requestFullscreen()}
              class="button is-small is-light"
              aria-label="Enter fullscreen mode"
            >
              <i class="bi bi-arrows-fullscreen"></i>
            </button>
            <!-- <button onclick={() => openPresetsModal()} class="btn btn-primary">
					<i class="bi bi-gear-fill" />
				</button> -->
          </div>
          <div id="presets_select" class="area">
            <button
              type="button"
              disabled={configuration?.addPreset ? false : true}
              onclick={() => confirmAddSceneToPresets()}
              class="button is-small is-light"
              aria-label="Add Scene to Preset"
            >
              <i class="bi bi-plus-circle-fill"></i>
            </button>
            <button
              type="button"
              disabled={configuration?.presets ? false : true}
              style="width:130px!important;display:inline-block!important"
              onclick={() => {
                openPresetsModal();
              }}
              class="button is-small {current_preset ? 'is-primary' : 'is-light'}"
              aria-label="Open Presets Modal"
              >{current_preset &&
              presets?.find((f) => f.token === current_preset)
                ? presets?.find((f) => f.token === current_preset)?.name
                : ""}
              <i style="float:right" class="bi bi-arrow-down-up"></i></button
            >
            <!-- <select
					onchange={(e) => {
						goToPreset(e);
					}}
					class="btn btn-primary"
					bind:value={current_preset}
				>
					{#each presets as preset (preset.id)}
						<option value={preset.id}>{preset.label || preset.id}</option>
					{/each}
				</select> -->
          </div>
          <div id="presets_buttons" class="area">
            <button
              type="button"
              disabled={!isVideoLoaded}
              onclick={() => {
                if (htmlVideoElement)
                  htmlVideoElement.muted = !htmlVideoElement.muted;
              }}
              class="button is-small {isVideoLoaded
                ? htmlVideoElement?.muted
                  ? 'is-warning'
                  : 'is-primary'
                : 'is-light'}"
              aria-label={htmlVideoElement?.muted
                ? "Unmute video"
                : "Mute video"}
            >
              <i
                class="bi bi-{htmlVideoElement?.muted || !htmlVideoElement
                  ? 'volume-mute-fill'
                  : 'volume-up-fill'}"
              ></i>
            </button>
            <button
              type="button"
              disabled={!isVideoLoaded}
              onclick={() => playOrPauseVideo()}
              class="button is-small {isVideoLoaded
                ? isVideoPlaying
                  ? 'is-primary'
                  : 'is-warning'
                : 'is-light'}"
              aria-label={isVideoPlaying ? "Pause video" : "Play video"}
            >
              <i
                class="bi bi-{isVideoPaused || !htmlVideoElement
                  ? 'pause-fill'
                  : 'play'}"
              ></i>
            </button>
            <button
              type="button"
              disabled={configuration?.settings ? false : true}
              onclick={() => showSettings()}
              class="button is-small is-light"
              aria-label="Open settings"
            >
              <i class="bi bi-sliders"></i>
              <span class="timecell">
                <!-- <i class="bi bi-clock" /> -->
                <span>{time}</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    {/if}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <div
      id="opener"
      onclick={() => {
        is_ptz_panel_opened = !is_ptz_panel_opened;
        dispatch("panelMove", { id, opened: is_ptz_panel_opened });
      }}
      style="left:{is_ptz_panel_opened ? '500' : '0'}px;"
    >
      <i
        class="bi {is_ptz_panel_opened
          ? 'bi-caret-left-fill'
          : 'bi-caret-right-fill'}"
      ></i>
    </div>
  {/if}
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
